// Typed DOM lookups. A missing element is a bug in the page, so these throw
// instead of handing back null.

export function byId<T extends HTMLElement = HTMLElement>(id: string): T {
  const el = document.getElementById(id);
  if (!el) throw new Error(`#${id} is missing from the page`);
  return el as T;
}

export function one<T extends Element = HTMLElement>(root: ParentNode, selector: string): T {
  const el = root.querySelector<T>(selector);
  if (!el) throw new Error(`${selector} is missing from the page`);
  return el;
}

export const all = <T extends Element = HTMLElement>(root: ParentNode, selector: string): T[] =>
  [...root.querySelectorAll<T>(selector)];
